import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './pages/theme';
import { Provider as StoreProvider } from 'react-redux';
import { store } from './store';
import { CookiesProvider, Cookies } from "react-cookie";
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createMsalConfig, graphConfig, isAdEnabled, TenantConfig } from './authConfig';
import { fetchTenant, fetchUserAD } from "./reducers/fetchWebService";

async function callMsGraph(accessToken) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
      method: "GET",
      headers: headers
  };

  const response = await fetch(graphConfig.graphMeEndpoint, options);
  if (!response.ok) {
    throw new Error(`Microsoft Graph devolvió ${response.status}`);
  }
  return response.json();
}  

async function LoginUser(userPrincipalName, displayName) {
  const cookie = new Cookies();
  const idUser = cookie.get("Id_User");

  if (idUser != null) {
    window.location.replace('/');
    return;
  }

  const resultado = await fetchUserAD(userPrincipalName, displayName);

  if (!resultado || !resultado.Id_User) {
    window.location.replace('/login?errorLogin=1');
    return;
  }

  cookie.set('Id_User', resultado.Id_User, { path: '/' });

  if (cookie.get("datosHome") == null) {
    cookie.set('datosHome', [{
      userId: resultado.Id_User,
      abiertos: [],
      columnas: [6,6,6,6,6,6,6,6,6],
      componentes: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    }], { maxAge: 99999999, path: '/' });
  }

  window.location.replace('/');
}

function renderApp(msalInstance: PublicClientApplication) {
  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <StoreProvider store={store}>
          <ThemeProvider theme={theme}>
            <CookiesProvider>
              <CssBaseline />
              <App />
            </CookiesProvider>
          </ThemeProvider>
        </StoreProvider>
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

async function bootstrap() {
  try {
    const tenant = await fetchTenant() as TenantConfig;

    if (!tenant || !tenant.Id_Tenant) {
      throw new Error('La configuración del tenant es inválida');
    }
    if (isAdEnabled(tenant) && (!tenant.ClientId || (!tenant.Authority && !tenant.Tenant))) {
      throw new Error('La configuración de Active Directory está incompleta');
    }

    const msalInstance = new PublicClientApplication(createMsalConfig(tenant));
    let tokenResponse;
    try {
      tokenResponse = await msalInstance.handleRedirectPromise();
    } catch (error) {
      console.error('Active Directory rechazó o canceló la autenticación', error);
      window.location.replace('/login?errorLogin=2');
      return;
    }

    if (tokenResponse && tokenResponse.account) {
      try {
        const accessTokenResponse = await msalInstance.acquireTokenSilent({
          scopes: ["User.Read"],
          account: tokenResponse.account,
        });
        const profile = await callMsGraph(accessTokenResponse.accessToken);
        await LoginUser(profile.userPrincipalName, profile.displayName);
        return;
      } catch (error) {
        console.error('Error al validar el ingreso por Active Directory', error);
        window.location.replace('/login?errorLogin=2');
        return;
      }
    }

    renderApp(msalInstance);
  } catch (error) {
    console.error('No se pudo iniciar la aplicación', error);
    ReactDOM.render(
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        No se pudo cargar la configuración del sistema. Intente nuevamente.
      </div>,
      document.getElementById('root')
    );
  }
}

bootstrap();
